import { FC, useEffect, useRef, useState } from 'react';
import {
    ColumnDirective,
    ColumnsDirective,
    CommandColumn,
    DataStateChangeEventArgs,
    Edit,
    Filter,
    GridComponent,
    Inject,
    Page,
    Sort,
} from '@syncfusion/ej2-react-grids';
import { useDispatch, useSelector } from 'react-redux';
import '../Grid.scss';
import { setSelectedRecrdsExport } from '../../contactTabs/contactReducer';
import { customizeCell } from '../CustomCell';
import { setRowData, setRowId } from '../gridReducer';
import {
    FilterOptions,
    getDefaultFilterOperator,
    pageOptions,
    selectionOptions,
} from '../gridConfig';
import { filterQuery } from '../grid-events';
import loader from '../../../assets/loader.gif';
import {
    setUserAccessData,
    setIsGridRefresh,
} from '../../accessMgmt/accessmgmtReducer';
import { getFilteredUsers, userMgmtHeaders } from '../../accessMgmt/utils';
import { RootState } from '../../../redux/store';

interface Props {
    hideSpinner?: boolean;
    width?: string;
    height?: string;
    onRowSelect?: (selectedRecords: any[]) => void;
    onRowDeselect?: (selectedRecords: any[]) => void;
}

const UserMngmtGrid: FC<Props> = ({ hideSpinner = false, height }) => {
    const gridRef = useRef<GridComponent | null>(null);
    const [loaderStatus, setLoaderStatus] = useState(true);
    const dispatch = useDispatch();
    const [searchParams, setSearchParams] = useState({});

    const isGridRefresh = useSelector(
        (state: RootState) => state.accessMgmtReducer.isGridRefresh
    );

    const aliveRef = useRef(true);

    useEffect(() => {
        return () => {
            aliveRef.current = false;
        };
    }, []);

    const handleSelectedRow = (event: any) => {
        dispatch(
            setSelectedRecrdsExport(gridRef?.current?.getSelectedRecords())
        );
        const selectedrecords: object[] =
            gridRef?.current?.getSelectedRecords() ?? [];

        if (selectedrecords && selectedrecords.length > 0) {
            dispatch(setRowData(selectedrecords));
            dispatch(setRowId(event.data));
        }
    };

    const dataStateChange = (
        state: DataStateChangeEventArgs,
        enableFilterQuery: boolean = false
    ) => {
        try {
            setLoaderStatus(true);
            dispatch(setIsGridRefresh(false));
            const reqParams: any = enableFilterQuery
                ? state
                : filterQuery(state);
            setSearchParams(reqParams);
            getFilteredUsers(reqParams).then((data) => {
                if (!aliveRef.current) return;
                setLoaderStatus(false);
                if (gridRef.current) {
                    gridRef.current.dataSource = [];
                    gridRef.current.dataSource = data;
                    //console.log(gridRef);
                    dispatch(setUserAccessData(data.result || []));
                    dispatch(setSelectedRecrdsExport(data.result || []));
                }
            });
        } catch (error) {
            setLoaderStatus(false);
            dispatch(setIsGridRefresh(false));
            console.error('Error occured in dataStateChange', error);
        }
    };

    useEffect(() => {
            dataStateChange({ skip: 0 });
    }, []);

    useEffect(() => {
        if (isGridRefresh) {
            dataStateChange(searchParams, true);
        }
    }, [isGridRefresh, searchParams]);

     const onFirstGridCreated = () => {
        if (gridRef.current) {
            //gridRef.current.locale="en-US";
            //   createSpinner({
            //     // Specify the target for the spinner to show
            //     target: document.getElementById('container') as HTMLElement,
            //     width: '30px'
            // });
            // showSpinner(document.getElementById('container') as HTMLElement);
            !hideSpinner && gridRef?.current?.showSpinner();
        }
        //createSpinner() method is used to create spinner

        // showSpinner() will make the spinner visible
    };

    return (
        <>
            <GridComponent
                id="FGrid"
                ref={gridRef}
                enableStickyHeader={true}
                dataStateChange={dataStateChange}
                queryCellInfo={customizeCell}
                created={onFirstGridCreated}
                rowHeight={48}
                width={"100%"}
                height={height}
                allowSorting={true}
                allowPaging={true}
                filterSettings={FilterOptions}
                allowFiltering={true}
                selectionSettings={selectionOptions}
                pageSettings={pageOptions}
                rowSelected={(event) => handleSelectedRow(event)}
                enablePersistence={false}
                // rowDeselected={(event) => handleSelectedRow(event)}
            >
                <ColumnsDirective>
                    <ColumnDirective type="checkbox" width="50" />
                    {userMgmtHeaders.map((col: any) => {
                        return (
                            <ColumnDirective
                                filter={getDefaultFilterOperator(col.dataType)}
                                key={col.field}
                                field={col.field}
                                headerText={col.header}
                                commands={col?.commands}
                                width={col.width ? col.width : '100'}
                                textAlign={col?.textAlign}
                            />
                        );
                    })}
                </ColumnsDirective>
                <Inject services={[Page, Sort, Filter, CommandColumn, Edit]} />
            </GridComponent>
            <div className="LoadImg">
                {loaderStatus ? (
                    <img className="loaderClass" src={loader} />
                ) : (
                    <></>
                )}
            </div>
        </>
    );
};
export default UserMngmtGrid;
